import { useSelector } from 'react-redux';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { selectHealingStats } from '../../../redux/locatorDrift/locatorDriftSlice';
import { topBreakersTableStyles } from './healingStyles';

export default function TopBreakersTable() {
  const stats = useSelector(selectHealingStats);
  const breakers = stats?.top_breakers || [];
  if (!breakers.length) return null;

  return (
    <Paper variant="outlined" sx={topBreakersTableStyles.root}>
      <Typography variant="subtitle2" fontWeight={800} sx={topBreakersTableStyles.title}>
        Most Frequently Breaking Locators
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Locator</TableCell>
            <TableCell align="right">Breaks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {breakers.map((breaker) => (
            <TableRow key={breaker.locator_value}>
              <TableCell sx={topBreakersTableStyles.locatorCell}>{breaker.locator_value}</TableCell>
              <TableCell align="right">{breaker.break_count}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
